export const NAVIGATION_LINKS = [
    {
        title: { ru: 'О нас', en: 'About Us', kz: 'Біз туралы' },
        href: '/about-us'
    },
    {
        title: { ru: 'Новости', en: 'News', kz: 'Жаңалықтар' },
        href: '/news'
    },
    {
        title: { ru: 'Клубы', en: 'Clubs', kz: 'Клубтар' },
        subMenu: [
            {
                title: { ru: 'Киноклуб', en: 'Cinema Club', kz: 'Киноклуб' },
                href: '/cinema-club'
            },
            {
                title: { ru: 'Книжный клуб', en: 'Book Club', kz: 'Кітап клубы' },
                href: '/book-club'
            },
            {
                title: { ru: 'Шахматный клуб', en: 'Chess Club', kz: 'Шахмат клубы' },
                href: '/chess-club'
            },
            {
                title: { ru: 'Поэтический клуб', en: 'Poetry Club', kz: 'Поэзия клубы' },
                href: '/poetry-club'
            }
        ]
    },
    {
        title: { ru: 'Курсы', en: 'Courses', kz: 'Курстар' },
        href: '/courses'
    },
    {
        title: { ru: 'Мероприятия', en: 'Events', kz: 'Іс-шаралар' },
        href: '/events'
    }
];
